import { call } from 'redux-saga/effects';
import { ReservationsResponse } from '@classpass/protobuf-definitions/lib/web/models/partners/reservation';

import { waitForModal } from 'components/Modal';
import URLS from 'constants/urls';

export function* confirmClassDisable(dependencies, { venueId, venueClass, entityType }) {
  const { httpClient } = dependencies;
  const { classId, className } = venueClass;
  const classReservationsResponse = yield call([httpClient, httpClient.get], URLS.class.reservations(venueId, classId));
  const { reservations } = ReservationsResponse.fromJSON(classReservationsResponse.data);

  return yield call(waitForModal, dependencies, 'DisableClassConfirmationModal', {
    classTitle: className,
    entityType,
    numberOfReservations: reservations?.length,
  });
}
